import React from 'react';
import { PenToolIcon, MonitorIcon, MegaphoneIcon, SparklesIcon } from 'lucide-react';
type Craft = {
  icon: React.ReactNode;
  title: string;
  blurb: string;
  tint: string;
};
const crafts: Craft[] = [{
  icon: <PenToolIcon size={22} data-id="element-244" />,
  title: 'Identity',
  blurb: 'Marks & systems built to last',
  tint: '#f15a24'
}, {
  icon: <MonitorIcon size={22} data-id="element-245" />,
  title: 'Web',
  blurb: 'Sites that read clearly, load fast',
  tint: '#3b4fe0'
}, {
  icon: <MegaphoneIcon size={22} data-id="element-246" />,
  title: 'Campaigns',
  blurb: 'Launches that move the numbers',
  tint: '#5b3bd9'
}, {
  icon: <SparklesIcon size={22} data-id="element-247" />,
  title: 'Craft',
  blurb: 'The details other studios skip',
  tint: '#f15a24'
}];
export function Studio() {
  return <section id="studio" className="sec" data-id="element-248">
      <div className="studio" data-id="element-249">
        <div data-id="element-250">
          <div className="eyebrow mb-5" data-id="element-251">The studio</div>
          <h2 data-id="element-252">
            We're here to <span className="serif" data-id="element-253">fuel</span> your growth.
          </h2>
          <p className="lead" data-id="element-254">
            Seven people in Nairobi who care a lot about the details most
            studios skip. We work in small, senior teams — no hand-offs to
            juniors, no design-by-committee.
          </p>
          <p className="lead" data-id="element-255">
            The goal is simple: work that earns attention, and a process that
            respects your time. When we're done, you own a brand that's easy to
            run without us.
          </p>
        </div>

        {/* Relatable craft illustrations (replaces the recognition list) */}
        <div className="awards p-6 md:p-8" aria-label="What the studio makes" data-id="element-256">
          <div className="grid grid-cols-2 gap-4" data-id="element-257">
            {crafts.map(c => <div key={c.title} className="rounded-r border border-line bg-canvas p-5 flex flex-col gap-3 transition-colors hover:border-line-2" data-id="element-258">
                <span className="w-11 h-11 rounded-full grid place-items-center" style={{
              background: `${c.tint}22`,
              color: c.tint
            }} aria-hidden="true" data-id="element-259">
                  {c.icon}
                </span>
                <div data-id="element-260">
                  <div className="font-semibold text-ink leading-tight" data-id="element-261">
                    {c.title}
                  </div>
                  <p className="text-mut text-sm mt-1 leading-snug" data-id="element-262">
                    {c.blurb}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}